import React from 'react';

export const ConsentStatus = ({ status, timestamp, createdBy }) => {
  if (!status || !timestamp) {
    return <></>
  };

  const consentDate = new Date(timestamp);
  return (
    <>
      <div>Consent: {status}</div>
      <div>Date: {consentDate.toLocaleString('en-GB',{ dateStyle: 'short'})} {consentDate.toLocaleString('en-GB',{ timeStyle: 'short' })}</div>
      <div>User: {createdBy}</div>        
    </>
  );
};